import { render, staticRenderFns } from "./FormCapitaMinima.vue?vue&type=template&id=ea3235d4"
import script from "./FormCapitaMinima.vue?vue&type=script&lang=js"
export * from "./FormCapitaMinima.vue?vue&type=script&lang=js"
import style0 from "./FormCapitaMinima.vue?vue&type=style&index=0&id=ea3235d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports